import { createIcon } from '@chakra-ui/react'

/**
 * GridPlus Icon
 *
 * Official GridPlus logo from brand assets
 * @see https://github.com/GridPlus/brand-assets
 */
export const GridPlusIcon = createIcon({
  displayName: 'GridPlusIcon',
  path: (
    <>
      <polygon
        points='590.89 72.05 558.48 72.05 558.48 40.17 557.93 40.17 533.88 40.17 531.4 40.17 531.4 72.05 498.99 72.05 498.99 97.58 531.4 97.58 531.4 129.46 558.48 129.46 558.48 97.58 590.89 97.58 590.89 72.05'
        fill='currentColor'
      />
      <path
        d='M169.59,188.13c-6.7,3.24-15.62,5.47-26.37,5.47-27,0-48.87-19.47-48.87-47.86s20.88-47.05,49.07-47.05c19.68,0,31.64,7.3,35.29,9.73l12.37-22.31c-5.27-3.44-20.28-13.58-48.87-13.58-45,0-76.87,32-76.87,73.21s31.84,73,76.26,73c29.81,0,46.65-10.75,54.35-16.63V145.94H169.59Z'
        fill='currentColor'
      />
      <path
        d='M336.4,125c0-32.76-23.8-53-59.48-53H224.53V218.75h28.8V176.8h25.26l28.59,41.95h34l-33.6-48.42C325.75,161.77,336.4,145.91,336.4,125Zm-62,26.51H253.33V97.29h21.29c19,0,31.93,10.22,31.93,27.75C306.55,141.11,293.82,151.55,274.41,151.55Z'
        fill='currentColor'
      />
      <rect x='366.35' y='72.03' width='28.8' height='146.72' fill='currentColor' />
      <path
        d='M558.33,146.62h0v-4.41H531.47v4.41s-.29,10.68-.76,14.2c-2.75,20.52-22.23,32.47-47.11,32.47H457.09V97.49h26.65V72H428.29V218.75h56.56c40.64,0,70.27-22.21,73.48-57.93C558.65,157.29,558.33,146.62,558.33,146.62Z'
        fill='currentColor'
      />
    </>
  ),
  viewBox: '0 0 656.49 290',
})
